(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-regular"]) return;
  try {
    
  // Temperature Rating Toggle
  document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('[data-unit-toggle]');
    
    toggleButtons.forEach(button => {
      button.addEventListener('click', function() {
        const block = this.closest('.temperature-rating-block, .product-info-drawer__protection-rating');
        if (!block) return;
        
        const currentUnit = block.querySelector('.temperature-rating__current-unit, .product-info-drawer__protection-rating-current-unit');
        const currentValue = block.querySelector('.temperature-rating__current-value, .product-info-drawer__protection-rating-current-value');
        const tempCelsius = parseInt(block.dataset.temperature);
        const rangeTemps = block.querySelectorAll('.temperature-rating__range-temp, .product-info-drawer__protection-rating-range-temp');
        const pointer = block.querySelector('.temperature-rating__pointer, .product-info-drawer__protection-rating-pointer');
        const toggleText = this.querySelector('.temperature-rating__toggle-text, .product-info-drawer__protection-rating-toggle-text');
        
        // Store the original pointer position - it should not change when toggling units
        let originalPosition = '';
        if (pointer) {
          originalPosition = pointer.style.left || window.getComputedStyle(pointer).left;
        }
        
        if (currentUnit.textContent === '°C') {
          // Switch to Fahrenheit
          const tempFahrenheit = Math.round((tempCelsius * 9/5) + 32);
          currentValue.textContent = tempFahrenheit + '°F';
          currentUnit.textContent = '°F';
          if (toggleText) toggleText.textContent = 'Switch to °C';
          
          // Update range labels to Fahrenheit
          rangeTemps.forEach(range => {
            if (range.dataset.fahrenheit) {
              range.textContent = range.dataset.fahrenheit;
            }
          });
          
          // Keep the same pointer position - don't recalculate
          if (pointer && originalPosition) {
            pointer.style.left = originalPosition;
            pointer.style.display = 'block';
          }
          
        } else {
          // Switch to Celsius
          currentValue.textContent = tempCelsius + '°C';
          currentUnit.textContent = '°C';
          if (toggleText) toggleText.textContent = 'Switch to °F';
          
          // Update range labels to Celsius
          rangeTemps.forEach(range => {
            if (range.dataset.celsius) {
              range.textContent = range.dataset.celsius;
            }
          });
          
          // Keep the same pointer position - don't recalculate
          if (pointer && originalPosition) {
            pointer.style.left = originalPosition;
            pointer.style.display = 'block';
          }
        }
      });
    });
    
  });

  } catch(e) { console.error(e); }
})();
})();
